import { useNavigate } from "react-router-dom";

import { ROUTES } from "../../../../constants/routes";
import styles from "./ActorCard.module.scss";

type Props = {
  actorId: number | undefined
  fullName: string
  description: string
  image: string
}

const ActorCard = ({ actorId, fullName, description, image }: Props) => {
  const navigate = useNavigate();

  const clickHandler = () => {
    if (actorId) navigate(`${ROUTES.ACTORS}/${actorId}`);
  };

  return (
    <div className={styles.wrapper} onClick={clickHandler} style={actorId ? undefined : { cursor: "default" }}>
      <img
        width={130}
        height={130}
        className={styles.image}
        src={image ? image : ""}
        alt="#"
      />
      <div className={styles.textWrapper}>
        <h3 className={styles.fullName}>{fullName}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  )
}

export default ActorCard
